import React from 'react';
import { Alert, Snackbar, Typography } from '@mui/material';
import { validateReference } from '../../helpers/referenceValidation';

interface ReferenceValidationAlertProps {
	providerId: string;
	reference: string;
}

const ReferenceValidationAlert: React.FC<ReferenceValidationAlertProps> = ({
	providerId,
	reference,
}: ReferenceValidationAlertProps) => {
	const result = validateReference(providerId, reference);

	if (!result) return null;

	return (
		<Snackbar open={!result.valid} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ mb: 2 }}>
			<Alert
				severity="warning"
				variant="filled"
				sx={{
					width: '100%',
					maxWidth: 600,
					backgroundColor: '#f59e0b',
					color: '#000',
					'& .MuiAlert-icon': { color: '#000' },
				}}
			>
				<Typography variant="body2" fontWeight="bold">
					💩 ALGO NO HUELE BIEN CON EL {result.rule.referenceLabel.toUpperCase()} DE ESTE SERVICIO
				</Typography>
				<Typography variant="body2" sx={{ mt: 0.5 }}>
					El formato esperado para <strong>{result.rule.providerName}</strong> es: {result.rule.formatDescription}
				</Typography>
			</Alert>
		</Snackbar>
	);
};

export default ReferenceValidationAlert;
